/* Scroll indicator for the sub-collection chip strip (collection-subnav.liquid).
 * The chips scroll sideways natively; on a phone that is not obvious, so this
 * drives a small progress thumb under the strip, in the same format as the
 * theme's slider progressbar, to say "this moves" (owner, 2026-09-04).
 *
 * The strip is native overflow scroll, not a Swiper, so there is no built-in
 * scrollbar to reuse: this measures scrollLeft against the overflow and sizes
 * and moves the thumb. It marks the nav .has-overflow only when the strip
 * actually overflows, and the CSS shows the bar on phone widths only. No
 * dependency, rAF-throttled, passive listeners. */
(function () {
  function setup(nav) {
    var scroll = nav.querySelector('[data-subnav-scroll]');
    var bar = nav.querySelector('[data-subnav-bar]');
    var thumb = nav.querySelector('[data-subnav-thumb]');
    if (!scroll || !bar || !thumb) return;

    var raf = null;
    function update() {
      raf = null;
      var sw = scroll.scrollWidth;
      var cw = scroll.clientWidth;
      var overflow = sw - cw > 2;
      nav.classList.toggle('has-overflow', overflow);
      if (!overflow) return;
      var trackW = bar.clientWidth;
      if (!trackW) return;
      var thumbW = Math.max(Math.round(trackW * (cw / sw)), 24);
      var maxScroll = sw - cw;
      var pos = maxScroll > 0 ? scroll.scrollLeft / maxScroll : 0;
      var x = Math.round((trackW - thumbW) * pos);
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }
    function schedule() {
      if (raf == null) raf = requestAnimationFrame(update);
    }

    scroll.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
    // The heading font (Oswald) can change chip widths after it loads, which
    // changes the overflow; recompute once it has almost certainly arrived.
    setTimeout(update, 400);
  }

  function init() {
    var navs = document.querySelectorAll('.collection-subnav');
    for (var i = 0; i < navs.length; i++) setup(navs[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
